import axiosClient from "./axiosClient";

// AR (accounts-receivable) Invoice Details review.
// Mirrors paystubApiService but targets the ar_invoice_api blueprint: amounts
// are billing-rate based and "Finalize" writes ar_invoice_details rows.

export function fetchInvoiceReview(data) {
  return axiosClient.post("/ar_invoice_api/review", data);
}

export function finalizeSelectedInvoiceDetails(data) {
  return axiosClient.post("/ar_invoice_api/finalize", data);
}

export function voidSelectedInvoiceDetails(data) {
  return axiosClient.post("/ar_invoice_api/void", data);
}

// Invoices tab: generated invoices + un-invoiced "Review" groups, and the
// action that generates ar_invoices for those groups.
export function fetchInvoicesReview(data) {
  return axiosClient.post("/ar_invoice_api/invoices/review", data);
}

export function generateInvoices(data) {
  return axiosClient.post("/ar_invoice_api/invoices/generate", data);
}

export function cancelGeneratedInvoices(data) {
  return axiosClient.post("/ar_invoice_api/invoices/cancel", data);
}

// Miscellaneous tab: list/create/delete ar_miscellaneous rows for a pay period.
// Created rows leave invoice_id NULL — they're linked to an invoice later.
export function fetchMiscellaneous(data) {
  return axiosClient.post("/ar_invoice_api/miscellaneous/review", data);
}

// Billable plants (active_billable engagement) for the add-miscellaneous form.
export function fetchBillablePlants() {
  return axiosClient.get("/ar_invoice_api/miscellaneous/plants");
}

export function createMiscellaneous(data) {
  return axiosClient.post("/ar_invoice_api/miscellaneous/create", data);
}

export function deleteMiscellaneous(miscId) {
  return axiosClient.delete(`/ar_invoice_api/miscellaneous/${miscId}`);
}

// Fetch a single invoice's data for the React preview/print view.
export function fetchInvoiceView(invoiceId) {
  return axiosClient.get(`/ar_invoice_api/invoices/${invoiceId}`);
}

// Fetch the per-contractor detail report (the "separate attachment").
export function fetchInvoiceDetailReport(invoiceId) {
  return axiosClient.get(`/ar_invoice_api/invoices/${invoiceId}/detail-report`);
}

// Saved-vs-recalculated differences for the period's non-voided details.
export function fetchInvoiceDifferences(data) {
  return axiosClient.post("/ar_invoice_api/differences", data);
}
